'use client';

import { useClickAway } from '@uidotdev/usehooks';
import { ChevronDown } from '@v2/ui/Icon/Arrow';
import dynamic from 'next/dynamic';
import { useState } from 'react';

const ConcertsDropdownContent = dynamic(
  () =>
    import('./ConcertsDropdownContent').then(
      (module) => module.ConcertsDropdownContent
    ),
  { ssr: false }
);

interface Props {
  buttonStyle: string;
  variant: 'black' | 'white';
}

export const ConcertsDropdown = ({ buttonStyle, variant }: Props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownMenuRef = useClickAway<HTMLDivElement>(() => {
    setIsDropdownOpen(false);
  });

  return (
    <div ref={dropdownMenuRef}>
      <button
        aria-expanded={isDropdownOpen}
        onClick={() => setIsDropdownOpen((oldValue) => !oldValue)}
        className={`flex items-center gap-2 rounded-lg border-2 ${isDropdownOpen ? buttonStyle : 'border-transparent'}`}
      >
        Concerts <ChevronDown stroke={variant} size="20" />
      </button>
      {isDropdownOpen && <ConcertsDropdownContent />}
    </div>
  );
};

export { GenreDropdownIcons } from './GenreDropdownIcons';
export { SONG_CATEGORY, genreCategoriesList } from './concertCategories';
